// Should stay in sync with SurveyResultLabelType.cs
const SURVEY_RESULT_LABEL_TYPE = {
  Excellent: 'Excellent',
  AboveAverage: 'AboveAverage',
  Average: 'Average',
  BelowAverage: 'BelowAverage',
  Poor: 'Poor',
  Promoters: 'Promoters',
  Detractors: 'Detractors',
  Passives: 'Passives',
  Responses: 'Responses',
  Yes: 'Yes',
  Unsure: 'Unsure',
  No: 'No',
  Nps: 'Nps'
};

export default SURVEY_RESULT_LABEL_TYPE;
